import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import "./curvedShaped.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import useMediaQuery from '../../hooks/use-media-query';

const CurvedShape = (props) => {

  const isDesktop = useMediaQuery('(min-width: 576px)');
  // console.log(isDesktop);

  React.useEffect(() => {
    AOS.init({
      offset: 50,
      duration: 1000,
      easing: "ease",
    });

    AOS.refresh();
    setTimeout(function () {
      AOS.init();
    }, 1000);
  }, []);

  let bgImg = props.backgroundBg
  if (!isDesktop && props.backgroundBgMob) {
    bgImg = props.backgroundBgMob
  }

  return (
    <div
      className={`curved-block ${props.className}`}
      style={{ background: `url(${bgImg})` }}
    >
      <StaticImage
        className="left-curved"
        src="../../images/top-left-white-curved.png"
        alt="White Curve shaped"
        placeholder="none"
        quality={100}
      />
      <StaticImage
        className="right-curved"
        src="../../images/top-right-white-curved.png"
        alt="White Curve shaped"
        placeholder="none"
        quality={100}
      />
      <div className="centered-content">
        <div className="content" data-aos="fade-up">{props.children}</div>
      </div>
    </div>
  );
};

export default CurvedShape;
